import React from 'react';

const Probability = () => {
    return (
        <div>Probability Component</div>
    );
}

export default Probability;
